import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropdownTitleProps } from './types';

const inheritFont = {
  font: 'inherit',
  letterSpacing: 'inherit',
};

const useDropdownTitleStyles = makeStyles(({ spacing }) => {
  return createStyles({
    select: {
      ...inheritFont,
      padding: 0,
      width: (props: DropdownTitleProps) => props.dropdownTitleWidth,
    },
    selectedMenuItem: {
      ...inheritFont,
      fontSize: 'large',
      padding: spacing(),
      paddingTop: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  });
});

export default useDropdownTitleStyles;
